import './BackPayments.css';
import React, { useState, useEffect } from 'react';
import { Container } from '../../../components/Container/Container';
import { Card } from '../../../components/Card/Card';
import { Button } from '../../../components/Button/Button';
import { useMeta } from '../../../model/meta';
import { t } from '../../../locales/translate';
import { useAsyncValue } from '../../../model/data';
import { getBackPaymentLinks } from '../../../model/event';
import { Spinner } from '../../../components/Spinner/Spinner';
import { useErrorHandler } from '../../../util/util';
import { SimpleCheckbox } from '../../../components/Form/Checkbox/Checkbox';
import { useConfirmation } from '../../../components/ConfirmationPrompt/ConfirmationPrompt';
import { Grid } from '../../../components/Grid/Grid';

type paymentMethod = 'paypal' | 'bankTransfer';

export const BackPayments = (): JSX.Element => {
  useMeta({
    title: t.model.backPayments._title,
  });

  const [book, setBook] = useState(false);

  const [links, loading, error] = useAsyncValue(() => getBackPaymentLinks(), []);

  const [selectedMethod, setSelectedMethod] = useState<paymentMethod | null>(null);

  useErrorHandler(error);

  async function downloadAndBook(type: paymentMethod): Promise<void> {
    if (type) {
      window.open(links?.[`${type}AndBook`], '_blank');
    }
  }

  const { confirm } = useConfirmation({
    title: t.model.backPayments.confirmationTitle,
    message: t.model.backPayments.bookingConfirmation,
    action: async () => {
      if (selectedMethod) {
        await downloadAndBook(selectedMethod);
        setSelectedMethod(null);
      }
    },
    onClose: () => setSelectedMethod(null),
  });

  function downloadCSVs(type: paymentMethod): void {
    window.open(links?.[type], '_blank');
  }

  function handleOnClick(method: paymentMethod): void {
    if (book) {
      setSelectedMethod(method);
    } else {
      downloadCSVs(method);
    }
  }

  useEffect(() => {
    if (selectedMethod) {
      confirm();
    }
  }, [selectedMethod]);

  return (
    <Container>
      <Card title={t.model.backPayments._title}>
        {loading ? (
          <Spinner color="var(--color-tint)" />
        ) : (
          <Grid flex gap="sm">
            <Button
              type="primary"
              onClick={() => handleOnClick('paypal')}
              title={t.model.backPayments.downloadPending(t.model.bank.paypal)}
            />
            <Button
              type="primary"
              onClick={() => handleOnClick('bankTransfer')}
              title={t.model.backPayments.downloadPending(t.model.bank.bankTransfer)}
            />
            <SimpleCheckbox
              value={book}
              onChange={() => {
                setBook((value) => !value);
              }}
              label={t.model.backPayments.alsoBook}
            />
          </Grid>
        )}
      </Card>
    </Container>
  );
};
